module.exports = require('./helpers/bundle-url').getBundleURL('5Hutp') + "logo.c51670a8.svg";